function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dataLayer } from '@finect/front-gtm';
import { isObject } from '@finect/front-utils/isObject';
import { wrapInitialData } from '../utils';
import { getAction } from './loginAction';
import { getSubscriptions as _getSubscriptions, setSubscription as _setSubscription, fetchSubscription as _fetchSubscription, setLike as _setLike, fetchLike as _fetchLike, openOverlay as _openOverlay } from './actions';
export function withSubscriptions(WrappedComponent) {
  var entities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var withSubscriptionsComponent = function (_Component) {
    _inherits(withSubscriptionsComponent, _Component);
    var _super = _createSuper(withSubscriptionsComponent);
    function withSubscriptionsComponent() {
      var _this;
      _classCallCheck(this, withSubscriptionsComponent);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "handleEntityFollow", function (entityType, action, id, status, model) {
        dataLayer({
          id: action.charAt(0).toUpperCase() + action.slice(1),
          type: status ? action : "un".concat(action),
          params: {
            type: entityType,
            model: model && isObject(model) && model.hasOwnProperty('alias') ? {
              id: model.id,
              alias: model.alias
            } : {
              id: id
            }
          }
        });
        if (!_this.props.user.isLoggedIn) {
          _this.props.openOverlay(getAction(entityType, action, id, window.location.href));
          return;
        }
        if (action === 'subscribe') {
          _this.props.setSubscription("".concat(entityType, "s"), id, status);
          _this.props.fetchSubscription(entityType, id, status);
        }
        if (action === 'like') {
          _this.props.setLike("".concat(entityType, "s"), id, status);
          _this.props.fetchLike(entityType, id, status);
        }
      });
      return _this;
    }
    _createClass(withSubscriptionsComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.user.isLoggedIn) {
          this.props.getSubscriptions(entities);
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.user.isLoggedIn && !prevProps.user.isLoggedIn) {
          this.props.getSubscriptions(entities);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        var actions = {
          onAction: this.handleEntityFollow,
          onProductSubscriptionLegacy: function onProductSubscriptionLegacy(id, status) {
            _this2.handleEntityFollow('product', 'subscribe', id, status);
          }
        };
        var props = {
          subscriptions: this.props.subscriptions
        };
        return React.createElement(WrappedComponent, _extends({
          subscriptionsActions: actions,
          subscriptionsProps: props,
          handleEntityFollow: this.handleEntityFollow
        }, this.props));
      }
    }]);
    return withSubscriptionsComponent;
  }(Component);
  function loadInitialData(store, cookie) {
    return store.dispatch(_getSubscriptions(cookie, entities));
  }
  withSubscriptionsComponent.loadInitialData = wrapInitialData(WrappedComponent, loadInitialData);
  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      getSubscriptions: function getSubscriptions() {
        var entityTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        dispatch(_getSubscriptions('include', entityTypes));
      },
      openOverlay: function openOverlay(action) {
        dispatch(_openOverlay(action));
      },
      setSubscription: function setSubscription(entityCollection, id, status) {
        dispatch(_setSubscription(entityCollection, id, status));
      },
      fetchSubscription: function fetchSubscription(entityType, id, status) {
        dispatch(_fetchSubscription(entityType, id, status));
      },
      setLike: function setLike(entityCollection, id, status) {
        dispatch(_setLike(entityCollection, id, status));
      },
      fetchLike: function fetchLike(entityType, id, status) {
        dispatch(_fetchLike(entityType, id, status));
      }
    };
  };
  var mapStateToProps = function mapStateToProps(state) {
    return {
      user: state.user.user,
      subscriptions: state.user.subscriptions,
      likes: state.user.likes
    };
  };
  return connect(mapStateToProps, mapDispatchToProps)(withSubscriptionsComponent);
}